var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskInspectionRunway = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m19 19.493-5.911-1.875v4.128l1.486 1.136V24l-2.584-.74-2.566.74v-1.118l1.451-1.136v-4.128L5 19.493v-1.479l5.876-3.768v-4.128q0-.47.319-.793A1.07 1.07 0 0 1 11.99 9q.478 0 .788.325.31.324.31.793v4.128L19 18.014z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.4.12h1.2v3.224h-1.2zM11.4 4.92h1.2V8h-1.2zM21.5 0H23v23.76h-1.5zM1 0h1.5v23.76H1z"
})));
export default SvgTaskInspectionRunway;